import { render } from "./ServiceCategoryPrimaryAndControl.vue?vue&type=template&id=5edc561d&ts=true"
import script from "./ServiceCategoryPrimaryAndControl.vue?vue&type=script&lang=ts"
export * from "./ServiceCategoryPrimaryAndControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__